import { TextField, TextFieldProps } from '@mui/material';
import React from 'react';

interface TextInputProps extends Omit<TextFieldProps, 'value' | 'onChange'> {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  required?: boolean;
  helperText?: string;
  disabled?: boolean;
}

export const TextInput: React.FC<TextInputProps> = ({
  value,
  onChange,
  label,
  placeholder,
  required = false,
  helperText,
  disabled = false,
}) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      required={required}
      helperText={helperText}
      disabled={disabled}
      fullWidth
      margin="dense"
    />
  );
};
